import { patchAsync as _patchAsync } from "../../api";

const BASE_URL = "/calendar-guests";

export async function setGoingAsync(data) {
    return _patchAsync({ url: `${BASE_URL}/${data.calendarGuestId}/going`, data });
}
